import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
// Design system v2 (engine) first: tokens, faces, primitives, views, shell…
import './engine/design/tokens.css';
import './engine/design/fonts.css';
import './engine/design/engine.css';
import './engine/design/views.css';
import './engine/design/layout.css';
import './engine/design/shell.css';
import './engine/design/nova.css';
// …then the legacy component classes still used by pre-engine pages. They read the
// aliased tokens from tokens.css; index.css defines no tokens of its own any more.
import './index.css';
// Mobile LAST, so its phone/touch refinements win ties over everything above without
// needing !important. See engine/design/mobile.css.
import './engine/design/mobile.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
